import React from 'react';

const NotFound = () => {
    return (
        <div className="hero min-h-screen" style={{ background: `url(https://cdn.mos.cms.futurecdn.net/PuXipAW3AXUzUJ4uYyxPKC-1200-80.jpg)`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        </div>
    );
};

export default NotFound;